/**
* Based on https://raw.githubusercontent.com/plotly/plotly.js/master/lib/locales/pl.js
* and GWT client locale: szprot-server/src/main/resources/static/js/plotly-locale-pl.js
*/

'use strict';

module.exports = {
    moduleType: 'locale',
    name: 'pl',
    dictionary: {
        "Autoscale": "Skalowanie automatyczne",
        "Double-click on legend to isolate one trace": "Kliknij dwa razy na legendzie, aby wyświetlić tylko jeden rodzaj zdarzeń",
        "Double-click to zoom back out": "Kliknij dwa razy, aby oddalić",
        "Pan": "Przesuwanie",
        "Produced with Plotly": "Stworzone z użyciem Plotly",
        "Reset": "Resetuj",
        "Reset axes": "Zresetuj osie",
        "Snapshot succeeded": "Utworzono poprawnie",
        "Sorry, there was a problem downloading your snapshot!": "Wystąpił błąd podczas tworzenia i pobierania wykresu!",
        "Taking snapshot - this may take a few seconds": "Tworzenie wykresu, proszę czekać. Może to zająć do kilku sekund",
        "Zoom": "Powiększanie",
        "Zoom in": "Przybliż",
        "Zoom out": "Oddal",
        "Download plot as a png": "Eksportuj jako PNG"
    },
    format: {
        days: [
            'Niedziela', 'Poniedziałek', 'Wtorek', 'Środa',
            'Czwartek', 'Piątek', 'Sobota'
        ],
        shortDays: ['Nie', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
        months: [
            'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
            'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
        ],
        shortMonths: [
            'Sty', 'Lu', 'Mar', 'Kw', 'Maj', 'Cze',
            'Lip', 'Sie', 'Wrz', 'Pa', 'Lis', 'Gru'
        ],
        date: '%Y-%m-%d'
    }
};